// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Checkbox_style_b-icon-warning__tJDh0","checkbox":"Checkbox_style_checkbox__rYjrx","rotate":"Checkbox_style_rotate__wB0bO"};